import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1f8dfb37")

_pushScopeId("data-v-1f8dfb37")
const _hoisted_1 = {
  class: "result_area",
  style: {"display":"none"}
}
const _hoisted_2 = { class: "product_lst_area" }
const _hoisted_3 = { class: "prod_info_bx" }
const _hoisted_4 = { class: "prod_value" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("총 ")
const _hoisted_6 = { class: "value_txt" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("개 상품")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_sort_option_component = _resolveComponent("sort-option-component")
  const _component_product_list_component = _resolveComponent("product-list-component")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode("em", _hoisted_6, _toDisplayString(_ctx.totalCount), 1),
          _hoisted_7
        ]),
        _createVNode(_component_sort_option_component, {
          onLoadNewItem: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$.emit('load-new-item')))
        })
      ]),
      _createVNode(_component_product_list_component, { products: _ctx.products }, null, 8, ["products"])
    ])
  ]))
})